import type { BaseLogger, UnknownRecord } from '../types'

/**
 * @class ConsoleAdapter - quick and dirty bridge to the browser console
 *
 * Provides a `BaseLogger` compliant implementation that simply proxies each
 * log level to its matching `console.*` call. Intended for development or
 * fallback scenarios where a dedicated logging service is unavailable
 */
export class ConsoleAdapter implements BaseLogger {
  error(error: Error, metadata?: UnknownRecord): void {
    console.error(error, metadata)
  }

  log(error: Error, metadata?: UnknownRecord): void {
    console.log(error, metadata)
  }

  warn(error: Error, metadata?: UnknownRecord): void {
    console.warn(error, metadata)
  }

  info(error: Error, metadata?: UnknownRecord): void {
    console.info(error, metadata)
  }

  debug(error: Error, metadata?: UnknownRecord): void {
    console.debug(error, metadata)
  }
}
